module.exports = __webpack_public_path__ + "img/qr-code-scan.febb6031.svg";